import ModalsUtil from '../../../utils/modals';
import {useSelector} from 'react-redux';
import Selector from '../../../selectors/modals/bonus/bonus';
import {useState, useEffect} from 'react';
import Language from '../../../language';
import Bonuses from './bonuses';
import SoundsUtil from '../../../utils/sounds';
import ImageUtil from '../../../utils/image';

export default () => {
    const [state, setState] = useState('daily'),
          {stars_count} = useSelector(Selector),
          stars = [1,2,3,4,5,6];

    return (
        <div className={`modal ${state} modal-bonus animate__zoomIn animate__animated`} data-target="bonus" style={{display: 'none'}}>
            <div className="modal-close" onClick={e => ModalsUtil.close()}></div>

            <div className="buttons">
                <div className="button profile" onClick={e => {
                    SoundsUtil.click();
                    setState('daily')
                }}>
                    <div className="text">{Language('modals.bonus.nav.daily')}</div>
                </div>
                <div className="button information" onClick={e => {
                    SoundsUtil.click();
                    setState('weekly');
                }}>
                    <div className="text">{Language('modals.bonus.nav.weekly')}</div>
                </div>
            </div>

            <div className="modal-background"></div>

            <div className="title">{state === 'daily' ? Language('modals.bonus.daily.title') : Language('modals.bonus.weekly.title')}</div> 
            <div className="icon">
                {state === 'daily' ? (
                    <ImageUtil path={`/images/modals/bonus/bonus-daily-icon.png`} alt="Icon" />
                ) : (
                    <ImageUtil path={`/images/modals/bonus/bonus-weekly-icon.png`} alt="Icon" />
                )}
            </div>

            <div className="stars">
                {stars.map((_, key) => {
                    return (
                        <div className={`star ${key < stars_count ? 'active' : ''}`}></div>
                    )
                })}
            </div>

            <div className="balance">
                <div className="text">{Language('modals.bonus.amount', {amount: 14571.1})}</div>
            </div>

            <div className="users">
                <div className="text">{Language('modals.bonus.users', {count: 687})}</div>
            </div>

            <div className="progress">
                <div className="text-title">{Language('modals.bonus.progress')}</div>
                <div className="bonuses">
                    {state === 'daily' ? (
                        <>
                            <Bonuses.Daily.Online />
                            <Bonuses.Daily.Fishing />
                            <Bonuses.Daily.Slots />
                        </>
                    ) : (
                        <>
                            <Bonuses.Weekly.Online />
                            <Bonuses.Weekly.Fishing />
                            <Bonuses.Weekly.Slots />
                        </>
                    )}
                </div>
            </div>
        </div>
    )
} 